<div id="pagConfig" class="page-layout simple">

    <!-- HEADER -->
    <div class="header accent p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

        <div class="hero-text">
            <mat-icon [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}" class="hero-icon">settings</mat-icon>
            <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                {{'CONFIGURACION.CABECERA.TITULO' | translate}}
            </h1>
            <h3 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                {{'CONFIGURACION.CABECERA.DESCRIP' | translate}}
            </h3>
        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div fxLayout="column" fxLayoutAlign="center">

            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">

              <div class="course" *ngFor="let course of filteredCourses" fxFlex="100" fxFlex.gt-xs="50"
                fxFlex.gt-sm="33"  [ngClass]="course.category" [@animate]="{value:'*',params:{y:'100%'}}">

                  <div class="course-content" fxLayout="column" fxFlex="1 1 auto">

                      <div class="header" fxLayout="row" fxLayoutAlign="center center" [ngClass]="course.category + '-bg'">
                          <div class="category" fxFlex>
                            {{'CONFIGURACION.BOTONES.BOT'+course.id+'.TITULO' | translate}}
                          </div>
                          <!-- <div class="category" fxFlex>{{course.title}}</div> -->

                          <div class="length" fxLayout="row" fxLayoutAlign="center center">
                              <mat-icon class="length-icon s-40">check_circle</mat-icon>
                              <!-- <div class="min">{{course.length}} min</div> -->
                          </div>
                      </div>

                      <div class="content" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">
                          <!-- <div class="h1">{{course.title}}</div>
                          <div class="updated">Updated {{course.updated}}</div> -->
                          <mat-icon class="length-icon s-120">{{course.icon}}</mat-icon>
                      </div>

                      <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                          <button mat-button color="accent" [routerLink]="'/settings/'+course.slug+'/'">
                            {{'CONFIGURACION.BOTONES.BOT'+course.id+'.BOTON' | translate}}
                          </button>
                      </div>

                  </div>

              </div>

              <div class="no-courses" *ngIf="filteredCourses.length === 0">
                  No courses found!
              </div>

            </div>

        </div>

    </div>
    <!-- / CONTENT -->

</div>
